import Vue from 'vue';

export function notify(message, options = {}, classes = '', position, type) {
    Vue.$toast.open({
        message,
        type: 'default',
        duration: 3000,
        position: (screen.width < 992) ? 'bottom' : 'bottom-right',
        ...options,
    });
}


export function successNotify(message, options = {}, classes = '', position, type) {
  Vue.$toast.open({
    message: '<div>' + message + ' <span><img src="/themes/storefront/public/images/icon_cross_white.png" alt="Close"></span></div>',
    type: 'success',
    duration: 3000,
    position: 'top',
    ...options,
  });
}

export function errorNotify(message, options = {}, classes = '', position, type) {
  Vue.$toast.open({
    message: '<div>' + message + ' <span><img src="/themes/storefront/public/images/icon_cross_white.png" alt="Close"></span></div>',
    type: 'error',
    duration: 3000,
    position: 'top',
    ...options,
  });
}



export function trans(langKey, replace = {}) {
    let line = window.Trillion.langs[langKey];

    for (let key in replace) {
        line = line.replace(`:${key}`, replace[key]);
    }

    return line;
}

export function isEmpty(value) {
    return $.isEmptyObject(value);
}

export function chunk(array, size) {
    let chunkedArray = [];
    let index = 0;

    while (index < array.length) {
        chunkedArray.push(array.slice(index, size + index));
        index += size;
    }

    return chunkedArray;
}

export function slickPrevArrow() {
    if (window.Trillion.rtl) {
        return `<div class="arrow-prev">
                    <i class="las la-angle-right"></i>
                </div>`;
    }

    return `<div class="arrow-prev">
                <i class="las la-angle-left"></i>
            </div>`;
}

export function slickNextArrow() {
    if (window.Trillion.rtl) {
        return `<div class="arrow-next">
                    <i class="las la-angle-left"></i>
                </div>`;
    }

    return `<div class="arrow-next">
                <i class="las la-angle-right"></i>
            </div>`;
}
export function convertSymbolToType(symbol) {
    if (symbol === '%') return 'percentage'
    if (symbol === '$') return 'amount'

}

export function convertTypeToSymbol(type) {
    if (type === 'percentage') return '%'
    if (type === 'amount') return '$'

}

export function currencyFormat(amount, defaultValue = 0, maxFractionDigits = 2) {

    if (amount === undefined || amount === null)
    return defaultValue;

  // Convert the amount to a string.
  let amountString = amount.toString();

  // Split the string into the integer and decimal parts.
  let [integerPart, decimalPart] = amountString.split('.');

  // If there is a decimal part and it's longer than two digits, truncate it.
  if (decimalPart && decimalPart.length > 2) {
    decimalPart = decimalPart.substring(0, 2);
  }

  // Format the integer part with commas.
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');


  // Add zeros to the decimal part if it doesn't exist but maxFractionDigits is greater than 0.
  if (!decimalPart && maxFractionDigits > 0) {
    decimalPart = '0'.repeat(maxFractionDigits);
  } else if (decimalPart && decimalPart.length < maxFractionDigits) {
    // Add trailing zeros to the decimal part if its length is less than maxFractionDigits.
    decimalPart = decimalPart + '0'.repeat(maxFractionDigits - decimalPart.length);
  }

  // Combine the integer part and decimal part if decimal exists and is not '00' or '0'.
  if ((decimalPart && !/^0+$/g.test(decimalPart)) || (decimalPart && maxFractionDigits != 0)) {
    return integerPart + '.' + decimalPart;
  } else {
    return integerPart;
  }

}

export function removeCurrencyFormat(amount, defaultValue = '') {
    if (!amount) return defaultValue
    const temp = '' + amount
    return temp.replace(/[^0-9.]|(?:\..*)\./g, '');
}
